module.exports = __webpack_public_path__ + "img/music_off_hover.4748af1e.svg";